<template>
  <div class="page">
    <div class="interest-free">
      <img src="https://static.ndmicro.com/tmd/landing/straight/images/img_zi@2x.png" class="page-img"/>
      <header>
        <div>恭喜您，成功获得预授信额度(元)</div>
        <div>200,000</div>
        <div>最长用12个月，综合年化利率12%-24%<span class="desc-sub">（单利计算）</span></div>
      </header>
      <section>
        <div class="wings"></div>
        <div class="main">
          <div class="main-content"></div>
          <div class="button" @click="handleDownload">
            立即提现
          </div>
          <div class="list-item">
            <div class="item">
              <img
                src="https://static.ndmicro.com/tmd/landing/straight/images/icon_01.png"
                srcset="
                                    https://static.ndmicro.com/tmd/landing/straight/images/icon_01@2x.png 2x,
                                    https://static.ndmicro.com/tmd/landing/straight/images/icon_01@3x.png 3x
                                "
              />
              <div class="text-1">快速审批</div>
              <div class="text-2">最快5分钟放款</div>
            </div>
            <div class="item">
              <img
                src="https://static.ndmicro.com/tmd/landing/straight/images/icon_02.png"
                srcset="
                                    https://static.ndmicro.com/tmd/landing/straight/images/icon_02@2x.png 2x,
                                    https://static.ndmicro.com/tmd/landing/straight/images/icon_02@3x.png 3x
                                "
              />
              <div class="text-1">分期偿还</div>
              <div class="text-2">可分12期偿还</div>
            </div>
            <div class="item">
              <img
                src="https://static.ndmicro.com/tmd/landing/straight/images/icon_03.png"
                srcset="
                                    https://static.ndmicro.com/tmd/landing/straight/images/icon_03@2x.png 2x,
                                    https://static.ndmicro.com/tmd/landing/straight/images/icon_03@3x.png 3x
                                "
              />
              <div class="text-1">放心使用</div>
              <div class="text-2">正规持牌机构</div>
            </div>
          </div>
        </div>
      </section>
      <div class="foot">
      </div>
    </div>
    <section class="compliance">
      <p>贷款额度，放款时间，还款方式，还款期限等以实际审批结果为准(综合年化利率区间12%-24%，单利计算)</p>
      <p>贷款有风险，请根据个人能力合理贷款，理性消费，避免逾期</p>
    </section>
    <download-cover v-if="isShowMask" />
    <ios-download v-model="downloadVisible"></ios-download>
    <ios-wxmp-dialog v-model="iosWxmpQRCodeDialogVisible"></ios-wxmp-dialog>
    <ios-wxmp-link-dialog v-model="iosWxmpLinkDialogVisible"></ios-wxmp-link-dialog>
    <web-clip-pop v-model="webclipPopVisible" @onClose="webclipPopVisible=false"/>
    <web-clip-copy-pop v-model="copyPopVisible" @onClose="copyPopVisible=false"/>
  </div>
</template>

<script>
import { judgeClientSystem, isWxMiniprogram, isBaiduMiniprogram } from '@/assets/utils'
import DownloadCover from '@/components/download-cover'
import IosDownload from '@/components/ios-download'
import IosWxmpDialog from '@/components/ios-wxmp-qrcode-dialog'
import IosWxmpLinkDialog from '@/components/ios-wxmp-link-dialog'
import isIntercept from '@/assets/intercept-mixin'
import WebClipPop from '../components/web-clip-pop.vue'
import WebClipCopyPop from '../components/web-clip-copy-pop.vue'

export default {
  name: 'straight-result',

  components: {
    DownloadCover,
    IosDownload,
    WebClipPop,
    WebClipCopyPop,
    IosWxmpDialog,
    IosWxmpLinkDialog
  },
  async created () {
    this.$bus.$emit('ready')
    this.channel = this.$route.query.channel || this.$storage.get('channel') || 'official'
    await isIntercept(this.channel)

    if (window && window.my && window.my.getEnv) {
      window.my.getEnv(function (res) {
        if (res.miniprogram) { // 当前是小程序环境，postMessage到webview执行跳转
          window.my.postMessage({
            actionType: 3,
            url: location.href
          })
        }
      })
    }
    if (this.auto === 'T' && !this.isShowMask) {
      this.handleDownload()
    }
  },
  data () {
    return {
      home: this.$route.query.home, // 是否直接跳转首页，值为T
      auto: this.$route.query.auto, // 是否自动下载，值为T
      isIos: judgeClientSystem() === 'IOS',
      downloadVisible: false,
      iosWxmpQRCodeDialogVisible: false,
      iosWxmpLinkDialogVisible: false,
      channel: '',
      webclipPopVisible: false,
      copyPopVisible: false
    }
  },
  computed: {
    downloadButtonTitle () {
      if (isWxMiniprogram() || isBaiduMiniprogram()) {
        return '点击复制链接到浏览器打开'
      }
      return `下载${this.isIos ? this.packageKey : '天美贷'}立即提现`
    }
  },
  methods: {
    // 下载事件
    handleDownload () {
      this.$report({
        id: 50019,
        args: {
          target: 'STRAIGHT_RESULT'
        }
      })
      this.downloadApp()
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.page {
    font-size: 28px;
    height: unset;
    width: 750px;
    background: #A7BFFF !important;
}
.interest-free {
      background: linear-gradient(180deg, #5E50B6 0%, #A7BFFF 100%);
      padding:0 40px;
  .page-img{
    width: 335px;
    height: 60px;
    margin:39px 0 70px;
  }
  .wings{
      background: url("https://static.ndmicro.com/tmd/landing/straight/images/img_jinbi@2x.png");
      background-size: 100% 100%;
      width: 750px;
      height: 385px;
      position: absolute;
      left: 0;
      top:380px;
      z-index: 1;
    }
  .main{
    margin:auto;
    width: 670px;
    height: 830px;
    background: #FFFFFF;
    border-radius: 30px;
    padding:73px 0 0;
    position: relative;
    z-index:2;
    .main-content{
      margin:auto;
      width: 534px;
      height: 295px;
      background: url("https://static.ndmicro.com/tmd/landing/straight/images/img_kuang@2x.png");
      background-size: 100% 100%;
    }
       .property {
         display: flex;
          margin: 128px auto 0;
          padding-bottom: 75px;
            .property-item {
                flex: 1;
                display: flex;
                flex-direction: column;
                align-items: center;
                text-align: center;
                .item-icon {
                  width: 120px;
                  height: 120px;
                    img {
                      width: 100%;
                      height: 100%;
                    }
                }
                .item-content {
                    :first-child {
                        height: 40px;
                        font-size: 28px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #333333;
                        line-height: 40px;
                    }
                    :last-child {
                        height: 33px;
                        font-size: 24px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #999999;
                        line-height: 33px;
                    }
                }
            }
        }
  }
  header{
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    padding-bottom: 44px;
    div:nth-child(1){
      height: 50px;
      font-size: 36px;
      line-height: 50px;
    }
    div:nth-child(2){
      height: 145px;
      font-size: 120px;
      font-family: DIN-Medium, DIN;
      font-weight: 500;
      line-height: 145px;
    }
    div:nth-child(3){
      height: 30px;
      font-size: 22px;
      line-height: 30px;
      .desc-sub{
          font-size: 20px;
      }
    }
  }
    .button {
            position: relative;
            width: 560px;
            height: 154px;
            text-align: center;
            line-height: 154px;
            margin: 40px auto 0;
            color: #fff;
            font-size: 36px;
            font-weight: 600;
            background: url(https://static.ndmicro.com/tmd/landing/straight/images/btn_jiekuan@2x.png) center no-repeat;
            background-size: 100%;
            animation: rotate 1.5s linear infinite;

            @keyframes rotate {
                0% {
                    transform: scale(1);
                }
                50% {
                    transform: scale(0.9);
                }
                100% {
                    transform: scale(1);
                }
            }
        }
        .list-item {
            display: flex;
            justify-content: space-between;
            padding: 0 60px;
            margin-top: 50px;
            .item {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                > img {
                    width: 90px;
                    height: 90px;
                }
                .text-1 {
                    margin-top: 18px;
                    font-size: 28px;
                    text-align: center;
                    color: #333333;
                    line-height: 40px;
                }
                .text-2 {
                    font-size: 24px;
                    text-align: center;
                    color: #999999;
                    line-height: 40px;
                }
            }
        }
    .foot{
    padding: 40px 0 36px;
    margin: auto;
    text-align: center;
    line-height: 28px;
    img{
      height: 21px;
      width: 21px;
    }
    span{
    height: 28px;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 28px;
    }
  }
}
.compliance{
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: 160px;
    background: #736CCC;
    line-height: 160px;
    color: #B6B2E9;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 400;
    overflow: hidden;
    box-sizing: border-box;
    padding: 28px 30px;
    p {
        line-height: 1.6em;
    }
}
</style>
